import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaRegCalendar, FaUserFriends } from 'react-icons/fa';
import { Button, Modal, Radio } from 'antd';
import useWindowSize from 'library/hooks/useWindowSize';
import DateRangePickerBox from 'components/UI/DatePicker/ReactDates';
import ViewWithPopup from 'components/UI/ViewWithPopup/ViewWithPopup';
import InputIncDec from 'components/UI/InputIncDec/InputIncDec';
import {saveState} from 'library/helpers/localStorage' ;
import moment from 'moment';

import {
  FormWrapper,
  ComponentWrapper,
  RoomGuestWrapper,
  ItemWrapper,
} from './Room.style';
import { addPlural } from 'library/helpers/fonction';
import { DAY_SEMAINE_OBJECT_NUMBER, FORMAT_DATE_YMD, HORAIRE_DAY_USE, LIMIT_SIZE_CHAMBRE_PAGINATION, LIMIT_SIZE_PAGINATION } from 'library/helpers/constUtils';
import { SharedDataContext } from 'context/SharedDataProvider';
import { RadioGroupSearch, SimpleDatePickerComponentWrapper } from 'containers/Home/Search/Search.style';
import SingleDatePickerWrapper from 'components/UI/DatePicker/SingleDatePicker';

const calendarItem = {
  separator: '-',
  format: 'DD-MM-YYYY',
  locale: 'fr',
};

export default function SearchForm({
  param, 
  currency, 
  hotel,
  roomMax,
  setParamRoom,
  setLoader,
  loader, 
  setDiplayLoadMoreChambreBtn, 
  setChambreLoaded,
  loadMoreChambre,
  setDateSejour
}) {
  let navigate = useNavigate();
  
  const { width } = useWindowSize();
  let params = param ; //loadState("filtre") ;
  const [searchDate, setSearchDate] = useState(params?.date_range??{
    setStartDate: null,
    setEndDate: null,
  });

  /** for the day use check */
  const {
    isFiltreDayUseChecked, 
    filtreDayUseDate, 
    setFiltreDayUseDate, 
    filtreDayUseMomentJournee, 
    setFiltreDayUseMomentJournee
  } = useContext(SharedDataContext);

  const updateSearchDate = (dates) => {
    setSearchDate(dates);
    setDateSejour(dates);
  }
  


  const maxRoom = roomMax ;
  const modalError = (title, message) => {
    Modal.error({
      title: title,
      content: message,
      onOk() {
        return;
      }
    });
  };

  // Room guest state
  const [roomGuest, setRoomGuest] = useState({
    room: params?.room??1,
    guest: params?.guest??1,
  });
  const handleIncrement = (type) => {
    if (type == "room"){
      if (roomGuest[type] < maxRoom){
        setRoomGuest({
          ...roomGuest,
          [type]: roomGuest[type] + 1,
        });
      }
    }else{
      setRoomGuest({
        ...roomGuest,
        [type]: roomGuest[type] + 1,
      });
    }
  };
  const handleDecrement = (type) => {
    if (roomGuest[type] <= 1) {
      return false;
    }
    setRoomGuest({
      ...roomGuest,
      [type]: roomGuest[type] - 1,
    });
  };
  const handleIncDecOnChange = (e, type) => {
    let currentValue = e.target.value;
    if (type == "room"){
      if (currentValue && currentValue <= maxRoom){
        setRoomGuest({
          ...roomGuest,
          [type]: currentValue,
        });
      }
    }else{
      setRoomGuest({
        ...roomGuest,
        [type]: currentValue,
      });
    }
      
  };

  //check libelle plural by value
  const [pluralLibelleRoom, setPluralLibelleRoom] = useState('');
  const [pluralLibelleGuest, setPluralLibelleGuest] = useState('');

  useEffect(()=> {
    setPluralLibelleRoom(addPlural(roomGuest.room ?? 0));
    setPluralLibelleGuest(addPlural(roomGuest.guest ?? 0));
  }, [roomGuest])

  //room pagination params
  const [pageChambreDispoToLoad] = useState(0);


  // navigate to the search page
  const goToSearchPage = () => {
    let title = 'Disponibilité des chambres';
    let messageError = 'Ooups ! Une erreur est survenue';
    let data = { ...params, 
      date_range : searchDate, 
      ...roomGuest,
      momentJournee : filtreDayUseMomentJournee,
      date: filtreDayUseDate?.format(FORMAT_DATE_YMD),
      dayUse: isFiltreDayUseChecked
    };
    const endPoint = isFiltreDayUseChecked?'chambre-type-hebergements-day-use-filter':'chambre-type-hebergements-filter';
    const urlRecherche = `${process.env.REACT_APP_API_URL}/${endPoint}?page=${pageChambreDispoToLoad}&size=${LIMIT_SIZE_CHAMBRE_PAGINATION}`;


    if ((isFiltreDayUseChecked && filtreDayUseDate ) || ( (!isFiltreDayUseChecked) && (searchDate.setEndDate !== null || searchDate.setStartDate !== null))){
      saveState("filtre", data);
      try {
          let dataParam = {};
          if(isFiltreDayUseChecked) {
            dataParam = 
            {
              "chambreTypeHerbergement": [],
              "idHotel": hotel,
              "nombreChambre": roomGuest.room,
              "nombreVoyageur": roomGuest.guest,
              "date": filtreDayUseDate?.format(FORMAT_DATE_YMD),
              "momentJournee":filtreDayUseMomentJournee
            }
          } else {
            dataParam = 
            {
              "chambreTypeHerbergement": [],
              "dateDisponibiliteChambre": {
                "dateDepart": moment(searchDate.setEndDate,'DD-MM-YYYY').format('YYYY-MM-DD'),
                "dateEntree": moment(searchDate.setStartDate,'DD-MM-YYYY').format('YYYY-MM-DD')
              },
              "idHotel": hotel,
              "nombreChambre": roomGuest.room,
              "nombreVoyageur": roomGuest.guest,
            }
        }

        setLoader(true) ;
        fetch(urlRecherche, {
          method: "POST",
          headers : {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(dataParam),
        }).then(
          (res) =>
            res.json()
              .then((response => {
                setLoader(false) ;
                if (!res.ok) {
                  modalError(title, response.message);
                }else {
                  if (isFiltreDayUseChecked) {
                    //get tarif per item
                    response.content.map((item) => {
                      //update content item with dayUseTarif
                      let tarifsDayUse = [];
                      for (let i = 0; i < item.dayUses.length; i++) {
                        if (item.dayUses[i].momentJournee === filtreDayUseMomentJournee 
                            && DAY_SEMAINE_OBJECT_NUMBER[item.dayUses[i].jourSemaine.toLowerCase()].number === filtreDayUseDate.day()) {
                              tarifsDayUse = item.dayUses[i].tarifs;
                              break;
                        }
                      }
                      item.prixDayUseAriary = (tarifsDayUse.find(tarif => tarif.idDevise == 1))?.prix ?? 0;
                      item.prixDayUseEuro =  (tarifsDayUse.find(tarif => tarif.idDevise == 2))?.prix ?? 0;

                      return item;
                    })
                  }
                  setChambreLoaded(response.content);
                  setDiplayLoadMoreChambreBtn(!response.last);
                  loadMoreChambre(0);
                 // redirectToRoomPage(response); 
                  // return (
                  //   <React.Fragment>
                  //     <Room details={response} currency={currency} hotel={hotel} />
                  //   </React.Fragment>
                  // );
                  //return <Room details ={response} currency={currency} hotel={hotel}/>
                }
              }))
              .catch(err => {
                setLoader(false) ;
                modalError(title, messageError);
              })
        ).catch(err => {
            setLoader(false) ;
            modalError(title, messageError);
        });
      }
      catch (e) {
        setLoader(false) ;
        modalError(title, messageError);
      }
    }else{
      let texteDate = isFiltreDayUseChecked?'la date':'les dates';
      modalError(title, `Pour avoir la disponibilité des chambres, merci de saisir ${texteDate}.`);
    }
  };

  // const redirectToRoomPage = (filteredResults) => {
  //   const params = new URLSearchParams(window.location.search);
  //   params.set('filteredData', encodeURIComponent(JSON.stringify(filteredResults)));
  //   const baseUrl = window.location.href.split('?')[0];
  //   const newUrl = `${baseUrl}?${params.toString()}`;
  //   window.history.pushState(null, null, newUrl)
  //   //window.location.assign(newUrl);
  // }

  //trigger search page only once for day use on load
  useEffect(() => {
    if (isFiltreDayUseChecked && filtreDayUseDate) {
      goToSearchPage();
    } 
  }, []);

  return (
    <FormWrapper>
      
      {isFiltreDayUseChecked &&
        <>
        <ComponentWrapper>
        <FaRegCalendar className='calendar' />
          <SimpleDatePickerComponentWrapper>
            <SingleDatePickerWrapper
                placeholder='Date'
                showClearDate={true}
                numberOfMonths={1}
                format={'DD-MM-YYYY'}
                id="date_recherche"
                updateDate={setFiltreDayUseDate}
                initialDate={filtreDayUseDate}
              />
            </SimpleDatePickerComponentWrapper>
      </ComponentWrapper>
      <ComponentWrapper>
        <RadioGroupSearch>
          <Radio.Group
                options={HORAIRE_DAY_USE}
                onChange={(e) => setFiltreDayUseMomentJournee(e.target.value)}
                defaultValue={filtreDayUseMomentJournee}
                optionType="default"
                buttonStyle="solid"
              />
        </RadioGroupSearch>
      </ComponentWrapper>
      </>
      }

      {!isFiltreDayUseChecked &&
      <ComponentWrapper>
        <FaRegCalendar className="calendar" />
        <DateRangePickerBox
          item={calendarItem}
          startDateId="startDateId-id-home"
          endDateId="endDateId-id-home"
          startDatePlaceholderText = "Arrivée"
          endDatePlaceholderText = "Départ"
          updateSearchData={(setDateValue) => updateSearchDate(setDateValue)}
          startDate=
          {
            searchDate.setStartDate
              ? moment(searchDate.setStartDate,'DD-MM-YYYY')
              : null
          }
          endDate={
            searchDate.setEndDate
              ? moment(searchDate.setEndDate,'DD-MM-YYYY')
              : null
          }
          showClearDates={true}
          small={true}
          numberOfMonths={width > 600 ? 2 : 1}
          disabled={loader}
        />
      </ComponentWrapper>
    }

      <ComponentWrapper>
        <FaUserFriends className="user-friends" />
        <ViewWithPopup
          key={200}
          noView={true}
          className="room_guest"
          view={
            <Button type="default">
              <span>Chambre{pluralLibelleRoom} {roomGuest.room > 0 && `: ${roomGuest.room}`}</span>
              <span>-</span>
              <span>Voyageur{pluralLibelleGuest} {roomGuest.guest > 0 && `: ${roomGuest.guest}`}</span>
            </Button>
          }
          popup={
            <RoomGuestWrapper>
              <ItemWrapper>
                <strong>Chambre{pluralLibelleRoom}</strong>
                <InputIncDec
                  id="room"
                  increment={() => handleIncrement('room')}
                  decrement={() => handleDecrement('room')}
                  onChange={(e) => handleIncDecOnChange(e, 'room')}
                  value={roomGuest.room}
                  disabled={loader}
                />
              </ItemWrapper>
              <ItemWrapper>
                <strong>Voyageur{pluralLibelleGuest}</strong>
                <InputIncDec
                  id="guest"
                  increment={() => handleIncrement('guest')}
                  decrement={() => handleDecrement('guest')}
                  onChange={(e) => handleIncDecOnChange(e, 'guest')}
                  value={roomGuest.guest}
                  disabled={loader}
                />
              </ItemWrapper>
            </RoomGuestWrapper>
          }
        />
      </ComponentWrapper>
      <Button
        type="primary"
        htmlType="submit"
        size="large"
        onClick={goToSearchPage}
        loading={loader}
      >
        Chercher
      </Button>
    </FormWrapper>
  );
}
